import {
  PanelContainer,
  NodePanelProps,
} from "../../lib/panel/panel-container";
import { PanelGorgiasTicket } from "./panel-gorgias-ticket";

export function GorgiasActionNodePanel(props: NodePanelProps<any>) {
  return (
    <PanelContainer nodeProps={props}>
      <PanelGorgiasTicket />
    </PanelContainer>
  );
}
